import createIcon from '../../createIcon';

/**
 * @component @name PictureInPictureAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMTFIMTFWMTdIMTlWMTFaTTIzIDE5VjQuOThDMjMgMy44OCAyMi4xIDMgMjEgM0gzQzEuOSAzIDEgMy44OCAxIDQuOThWMTlDMSAyMC4xIDEuOSAyMSAzIDIxSDIxQzIyLjEgMjEgMjMgMjAuMSAyMyAxOVpNMjEgMTkuMDJIM1Y0Ljk3SDIxVjE5LjAyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PictureInPictureAlt = createIcon('PictureInPictureAlt', [
  [
    'path',
    {
      d: 'M19 11H11V17H19V11ZM23 19V4.98C23 3.88 22.1 3 21 3H3C1.9 3 1 3.88 1 4.98V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19ZM21 19.02H3V4.97H21V19.02Z',
      key: '16iaz2',
    },
  ],
]);

export default PictureInPictureAlt;
